export * from "./interview.inits";

import { APPLICATION_WRITIG_STEPS, MEETING_STATES } from "../constants";

export const initEducationItem = (educationItem = {}) => ({
    ...(educationItem || {}),
    institutionType: educationItem?.institutionType || null,
    institutionName: educationItem?.institutionName || null,
    institutionDist: educationItem?.institutionDist || null,
    attendingStatus: educationItem?.attendingStatus || null,
    attendingEndsAt: educationItem?.attendingEndsAt || null,
    attendingStartsAt: educationItem?.attendingStartsAt || null,
});

export const initWorkExperienceItem = () => ({
    // isRelevant: Boolean,
    type: null,
    companyName: null,
    description: null,
    duration: {
        startsAt: null,
        endsAt: null,
    },
});

export const initLanguageItem = (languageItem = {}) => ({
    ...(languageItem || {}),
    type: languageItem?.type || null,
    name: languageItem?.name || null,
    score: languageItem?.score || 0,
    tempId: Math.random(),
});

export const initOfficeSkillItem = (officeSkillItem = {}) => ({
    ...(officeSkillItem || {}),
    type: officeSkillItem?.type || null,
    name: officeSkillItem?.name || null,
    score: officeSkillItem?.score || 0,
    tempId: Math.random(),
});

export const initCertificationItem = (certificationItem = {}) => ({
    ...(certificationItem || {}),
    name: certificationItem?.name || null,
    desc: certificationItem?.desc || null,
    issuer: certificationItem?.issuer || null,
    issuedAt: certificationItem?.issuedAt || null,
    tempId: Math.random(),
});

export const initResume = (resume = {}) => ({
    ...resume,

    name: resume?.name || null,
    profile: resume?.profile || null,

    personalInformation: {
        ...(resume?.personalInformation || {}),

        name: resume?.personalInformation?.name || null,
        phone: resume?.personalInformation?.phone || null,
        email: resume?.personalInformation?.email || null,
        gender: resume?.personalInformation?.gender || null,
        bornAt: resume?.personalInformation?.bornAt || null,

        residence: {
            ...(resume?.personalInformation?.residence || {}),

            postcode: resume?.personalInformation?.residence?.postcode || null,
            address1: resume?.personalInformation?.residence?.address1 || null,
            address2: resume?.personalInformation?.residence?.address2 || null,
        },
    },

    education: {
        ...initEducationItem(resume?.education),
        otherEducations: resume?.education?.otherEducations || [],
    },

    workExperience: {
        ...(resume?.workExperience || {}),
        type: resume?.workExperience?.type || null,
        span: {
            ...(resume?.workExperience?.span || {}),
            years: resume?.workExperience?.span?.years || null,
            months: resume?.workExperience?.span?.months || null,
        },
        list: resume?.workExperience?.list || [],
    },

    languages: [...(resume?.languages || [])].map(initLanguageItem),

    officeSkills: [...(resume?.officeSkills || [])].map(initOfficeSkillItem),

    certifications: [...(resume?.certifications || [])].map(initCertificationItem),

    coverLetter: {
        ...(resume?.coverLetter || {}),
        subject: resume?.coverLetter?.subject || null,
        content: resume?.coverLetter?.content || null,
    },
});

export const initApplication = (application = {}) => ({
    ...application,

    _recruitment: application?._recruitment || null,

    writingStep: application?.writingStep || APPLICATION_WRITIG_STEPS.RESUME.value,

    resume: initResume(application?.resume),

    certification: {
        ...(application?.certification || {}),
        employmentType: application?.certification?.employmentType || null,
        jobDescription: application?.certification?.jobDescription || null,
        jobDurationsAt: application?.certification?.jobDurationAts || [null, null],
    },
});

export const initTexting = (texting = {}) => ({
    _meeting: texting._meeting || null,
    _recruitment: texting._recruitment || null,

    message: texting.message || null,
    addresser: {
        ...(texting.addresser || {}),
        _user: texting.addresser?._user || null,
        company: texting.address?.company || null,
        name: texting.addresser?.name || null,
        phone: texting.addresser?.phone || null,
        email: texting.addresser?.email || null,
    },
    addressees: [...(texting.addressees || [])],
});

export const initTextingAddressee = ({ _id, _applicant, resume } = {}) => ({
    _user: _applicant || null,
    _application: _id || null,
    name: resume?.personalInformation?.name || null,
    phone: resume?.personalInformation?.phone || null,
});

export const initMemo = () => ({
    _writer: null,
    _writee: null,
    content: null,
});

export const initMeeting = (meeting = {}) => ({
    ...meeting,

    recruitment: meeting?.recruitment || null,
    applications: [...(meeting?.applications || [])],

    title: meeting?.title || null,
    state: meeting?.state || MEETING_STATES.MATCHING_ON_GOING.value,

    matching: {
        ...(meeting?.matching || {}),
        startsAt: meeting?.matching?.startsAt || null,
        endsAt: meeting?.matching?.endsAt || null,
    },

    schedulesAvailable: [...(meeting?.schedulesAvailable || [])],
});

export const initMeetingSchedule = (schedule = {}) => ({
    ...schedule,

    _meeting: schedule?._meeting || null,
    _company: schedule?._company || null,
    _applicant: schedule?._applicant || null,
    _recruitment: schedule?._recruitment || null,
    _application: schedule?._application || null,

    date: schedule?.date || null,
    state: schedule?.state || null,
});

export const initRecruitmentField__application = (application = {}) => ({
    ...application,
    startsAt: application?.startsAt || null,
    endsAt: application?.endsAt || null,
    isOpenHiring: application?.isOpenHiring || false,
    closesOnHiring: application?.closesOnHiring || false,
});

export const initRecruitmentField__employment = (employment = {}) => ({
    ...employment,
    startsAt: employment?.startsAt || null,
    endsAt: employment?.endsAt || null,
    types: [...(employment?.types || [])],
    wage: {
        ...(employment?.wage || {}),
        type: employment?.wage?.type || null,
        value__min: employment?.wage?.value__min || 0,
        value__max: employment?.wage?.value__max || 0,
    },
    place: {
        ...(employment?.place || {}),
        isAbroad: employment?.place?.isAbroad || false,
        postcode: employment?.place?.postcode || null,
        address1: employment?.place?.address1 || null,
        address2: employment?.place?.address2 || null,
    },
});

export const initRecruitmentField__qualification = (qualification = {}) => ({
    ...qualification,
    educationLevel: {
        ...(qualification?.educationLevel || {}),
        items: [...(qualification?.educationLevel?.items || [])],
        includesToBe: qualification?.educationLevel?.includesToBe || false,
        isIrrelevant: qualification?.educationLevel?.isIrrelevant || false,
    },
    workExperience: {
        ...(qualification?.workExperience || {}),
        items: [...(qualification?.workExperience?.items || [])],
        years: qualification?.workExperience?.years || 0,
        months: qualification?.workExperience?.months || 0,
        isIrrelevant: qualification?.workExperience?.isIrrelevant || false,
    },
    age: {
        ...(qualification?.age || {}),
        value__min: qualification?.age?.value__min || 0,
        value__max: qualification?.age?.value__max || 0,
        isIrrelevant: qualification?.age?.isIrrelevant || false,
    },
    gender: {
        ...(qualification?.gender || {}),
        value: qualification?.gender?.value || null,
        isIrrelevant: qualification?.gender?.isIrrelevant || false,
    },
});

export const initRecruitmentField__recruiter = (recruiter = {}) => ({
    ...recruiter,
    name: recruiter?.name || null,
    phone: recruiter?.phone || null,
    email: recruiter?.email || null,
    hidesPhone: recruiter?.hidesPhone || false,
    hidesEmail: recruiter?.hidesEmail || false,
});

export const initRecruitment = (recruitment = {}) => ({
    ...recruitment,
    subject: recruitment?.subject || null,
    summary: recruitment?.summary || null,
    content: recruitment?.content ?? "(업무개요, 모집부문, 근무조건, 지원조건, 접수방법 등)",

    application: initRecruitmentField__application(recruitment?.application),
    employment: initRecruitmentField__employment(recruitment?.employment),
    qualification: initRecruitmentField__qualification(recruitment?.qualification),
    recruiter: initRecruitmentField__recruiter(recruitment?.recruiter),

    _questions: [...(recruitment?._questions || [])],
    questions: [...(recruitment?.questions || [])],

    _attachments: [...(recruitment?._attachments || [])],
    attachments: [...(recruitment?.attachments || [])],
});

export const initBank = (bank = {}) => ({
    ...bank,
    code: bank?.code || null,
    accountNumber: bank?.accountNumber || null,
    accountHolder: bank?.accountHolder || null,
});

export const initCashReceipt = (cashReceipt = {}) => ({
    ...cashReceipt,
    enabled: cashReceipt.enabled || false,
    content: cashReceipt.content || null,
});

export const initPointForm__account = (form = {}) => ({
    ...form,
    state: form.state || null,
    code: "point-order-account",
    meta: {
        ...(form.meta || {}),
        bank: initBank(form.meta?.bank),
        amount: form.meta?.amount || 0,
        sender: form.meta?.sender || null,
        cashReceipt: initCashReceipt(form.meta?.cashReceipt),
    },
});

export const initEmploymentFormField = (field = {}) => ({
    ...(field || {}),

    content: field?.content || null,
    type: field?.type || null,
    page: field?.page || 1,
    dataLabel: field?.dataLabel || null,

    axis: {
        ...(field?.axis || {}),
        x: field?.axis?.x || 0,
        y: field?.axis?.y || 0,
    },

    size: {
        ...(field?.size || {}),
        w: field?.size?.w || 0,
        h: field?.size?.h || 0,
    },

    isRequired: field?.isRequired || false,
});

export const initEmploymentForm = (form = {}) => ({
    ...(form || {}),
    name: form?.name || null,
    dataLabel: form?.dataLabel || "",
    pages: [...(form?.pages || [])],
    fields: [...(form?.fields || [])].map(initEmploymentFormField),
});

export const initEmploymentContract = (contract = {}) => ({
    ...(contract || {}),

    _form: contract?._form || null,
    _person: contract?._person || null,
    _application: contract?._application || null,
    // applications: [...(contract?.employment?.applications || [])],

    fields: [...(contract?.fields || [])].map(initEmploymentFormField),

    employment: {
        place: {
            _place: contract?.employment?.place?._id || null,
            title: contract?.employment?.place?.title || null,
            postcode: contract?.employment?.place?.postcode || null,
            address1: contract?.employment?.place?.address1 || null,
            address2: contract?.employment?.place?.address2 || null,
            geolocation: {
                type: "Point",
                coordinates: [contract?.employment?.place?.geolocation.coordinates[0] || [], contract?.employment?.place?.geolocation.coordinates[1] || []],
            },
        },
        date: {
            startsAt: contract?.employment?.date?.startsAt || null,
            endsAt: contract?.employment?.date?.endsAt || null,
            fixedCheck: contract?.employment?.date?.fixed || false,
        },

        hour: {
            startsAt: contract?.employment?.hour?.startsAt || null,
            endsAt: contract?.employment?.hour?.endsAt || null,
            fixedCheck: contract?.employment?.date?.fixed || false,
        },
    },
});
